import { getFieldTypeLabel } from "Store/FieldManagement/PropTypes";
import { isFieldInModuleFieldType } from "Store/Settings/Modules/PropTypes";

export const getCombinationDatasetByFieldType = (fieldsById: any, field: any, target_type: any) => {
    let validFields: any = [];
    field?.default?.fields?.forEach(id => {
        const cField = fieldsById?.[id];
        if (isFieldInModuleFieldType(target_type, cField?.type)) {
            validFields.push({
                label: `${cField?.name} (${getFieldTypeLabel(cField?.type)})`,
                value: field?.id + '+' + id
            });
        }
    });

    return validFields;
}